import { v4 as uuidv4 } from 'uuid';
import axios from './interceptor';
import { setItem, getItem, clearAuth, removeItem } from './storage';
import { CONFIG } from './config';
import { decodeJWT } from './jwt';

// Simple check if we have a valid ID token
export const getAuthenticated = () => {
  const flag = getItem('authenticated');
  const authed = flag === true || flag === 'true';
  console.log(`Checking authentication flag... ${authed ? 'AUTHENTICATED' : 'NOT AUTHENTICATED'}`);
  return authed;
};

// Get stored state
export const getState = () => {
  return getItem('state');
};

export const logout = async () => {
  const state = getItem('state');
  const postLogout = CONFIG.POST_LOGIN_REDIRECT_URI;
  const qs = [
    `state=${encodeURIComponent(state || '')}`,
    `post_logout_redirect_uri=${encodeURIComponent(postLogout)}`
  ].join('&');
  const logoutUri = `${CONFIG.AUTH_BASE_URL}/api/logout?${qs}`;
  window.location.replace(logoutUri);
};

export const login = async (postLoginRedirectUriOverride = '', retURL = '') => {
  // build the full redirect target first (no encoding yet)
  console.log('CONFIG:', CONFIG);
  console.log('Constructing login redirect URI with override:', postLoginRedirectUriOverride, 'and return URL:', retURL);
  const base = postLoginRedirectUriOverride || CONFIG.POST_LOGIN_REDIRECT_URI;
  // let URL() handle joining + query/hash safely (retURL may be '/x?y=1#z' or absolute)
  const fullRedirect = retURL ? `${base}${base.includes('?') ? '&' : '?'}returnUrl=${encodeURIComponent(retURL)}` : base;
  console.log('Login redirect URI constructed as:', fullRedirect);
  const state = uuidv4();
  setItem('state', state);
  // encode values that go into the OUTER query string
  const qs = [
    `state=${encodeURIComponent(state)}`,
    `post_login_redirect_uri=${encodeURIComponent(fullRedirect)}`
  ].join('&');
  const loginUri = `${CONFIG.AUTH_BASE_URL}/api/authenticate?${qs}`;
  window.location.replace(loginUri);
};

export const openSmartSearchOnLogin = (urlParams) => {
  urlParams.delete('openSmartSearch');
  const newUrl = urlParams.toString() ? `${window.location.pathname}?${urlParams.toString()}` : window.location.pathname;
  window.history.replaceState({}, '', newUrl);
}

// Get ID token for API requests
export const getIdToken = async () => {
  const state = getItem('state');
  if (!state) {
    console.log('No state found, cannot get ID token');
    return null;
  }
  try {
    console.log('Requesting ID token from server with state:', state);
    const response = await axios.get(`/api/id-token?state=${state}`, {
      baseURL: CONFIG.AUTH_BASE_URL,
      withCredentials: true // Important for session cookies
    });

    console.log('ID token response:', response.data);

    if (response.data?.id_token) {
      console.log('Storing ID token in storage');
      setItem('id_token', response.data.id_token);
      console.log('ID token stored, verifying:', getItem('id_token') ? 'SUCCESS' : 'FAILED');
      return response.data.id_token;
    }

    console.log('No ID token in response');
    return null;
  } catch (error) {
    console.error('Failed to get ID token:', error);
    return null;
  }
};
// Check authentication status using session cookies
export const authStatus = async () => {
  try {
    const response = await axios.get('/api/auth-status', {
      baseURL: CONFIG.AUTH_BASE_URL,
      withCredentials: true // Important for session cookies
    });

    // If authenticated, save the state from the response
    if (response.data?.authenticated && response.data?.state) {
      console.log('Saving state from auth-status:', response.data.state);
      setItem('state', response.data.state);
      setItem('authenticated', !!response.data.authenticated);
      setItem('expires_at', response.data.expires_at);
      setItem('id_token', response.data.id_token || '');
    } else {
      console.log('User not authenticated or no state in response');
      clearAuth();
      return { authenticated: false };
    }

    return response.data;
  } catch (error) {
    console.error('Auth status check failed:', error);
    return { authenticated: false };
  }
};
// Get stored ID token
export const getStoredIdToken = () => {
  const token = getItem('id_token');
  console.log('Getting stored ID token:', token ? 'FOUND' : 'NOT FOUND');
  return token;
};

export const getJWT = () => {
  const id_token = getItem('id_token');
  return id_token ? decodeJWT(id_token) : null;
};

export const getJWTSub = () => {
  const jwt = getJWT();
  const sub = jwt ? jwt.payload?.sub : '';
  const regex = /user\/([^/]+)\/([^/]+)/;
  let aoid, ooid;
  // Extract the values
  const matches = sub.match(regex);

  if (matches) {
    ooid = matches[1];
    aoid = matches[2];
  }
  return { aoid, ooid };
};